"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GoTo_exports = {};
__export(GoTo_exports, {
  default: () => GoTo_default
});
module.exports = __toCommonJS(GoTo_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.75781 4C4.75781 3.67448 4.86849 3.40104 5.08984 3.17969C5.32422 2.94531 5.59766 2.82812 5.91016 2.82812H15.0898C15.4023 2.82812 15.6693 2.94531 15.8906 3.17969C16.125 3.40104 16.2422 3.67448 16.2422 4V16.5C16.2422 16.8255 16.125 17.1055 15.8906 17.3398C15.6693 17.5612 15.4023 17.6719 15.0898 17.6719H5.91016C5.59766 17.6719 5.32422 17.5612 5.08984 17.3398C4.86849 17.1055 4.75781 16.8255 4.75781 16.5V14.8398C4.75781 14.6966 4.70573 14.5794 4.60156 14.4883C4.51042 14.3841 4.39323 14.332 4.25 14.332C4.10677 14.332 3.98307 14.3841 3.87891 14.4883C3.78776 14.5794 3.74219 14.6966 3.74219 14.8398V16.5C3.74219 17.099 3.95052 17.6133 4.36719 18.043C4.79688 18.4596 5.3112 18.668 5.91016 18.668H15.0898C15.6888 18.668 16.1966 18.4596 16.6133 18.043C17.043 17.6133 17.2578 17.099 17.2578 16.5V4C17.2578 3.40104 17.043 2.89323 16.6133 2.47656C16.1966 2.04688 15.6888 1.83203 15.0898 1.83203H5.91016C5.3112 1.83203 4.79688 2.04688 4.36719 2.47656C3.95052 2.89323 3.74219 3.40104 3.74219 4V5.66016C3.74219 5.80339 3.78776 5.92708 3.87891 6.03125C3.98307 6.1224 4.10677 6.16797 4.25 6.16797C4.39323 6.16797 4.51042 6.1224 4.60156 6.03125C4.70573 5.92708 4.75781 5.80339 4.75781 5.66016V4ZM9.73828 6.55859C9.82943 6.46745 9.9401 6.42188 10.0703 6.42188C10.2135 6.42188 10.3372 6.46745 10.4414 6.55859L13.7031 9.83984C13.8203 9.94401 13.8789 10.0807 13.8789 10.25C13.8789 10.4062 13.8203 10.543 13.7031 10.6602L10.4414 13.9219C10.3372 14.026 10.2135 14.0781 10.0703 14.0781C9.9401 14.0781 9.82943 14.026 9.73828 13.9219C9.63411 13.8307 9.58203 13.7201 9.58203 13.5898C9.58203 13.4466 9.63411 13.3229 9.73828 13.2188L12.1992 10.7578H3.83984C3.69661 10.7578 3.57292 10.7122 3.46875 10.6211C3.3776 10.5169 3.33203 10.3932 3.33203 10.25C3.33203 10.1068 3.3776 9.98958 3.46875 9.89844C3.57292 9.79427 3.69661 9.74219 3.83984 9.74219H12.2188L9.73828 7.26172C9.63411 7.17057 9.58203 7.0599 9.58203 6.92969C9.58203 6.78646 9.63411 6.66276 9.73828 6.55859Z",
      fill: "currentColor"
    }
  )
);
const SvgGoTo = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GoTo_default = SvgGoTo;
